import {useApolloClient} from '@apollo/client'

import {
  AllCountriesDocument,
  AllCountriesQuery,
  useAllCountriesQuery,
} from '@progyny/generated/graphql'

type UseAllCountriesOptions = {
  fetchPolicy?:
    | 'cache-first'
    | 'cache-and-network'
    | 'network-only'
    | 'no-cache'
}

export function useAllCountries(options?: UseAllCountriesOptions) {
  return useAllCountriesQuery({
    fetchPolicy: options?.fetchPolicy ?? 'cache-first',
    nextFetchPolicy: 'cache-first',
  })
}

export function useAllCountriesCache(): AllCountriesQuery | null {
  const client = useApolloClient()
  const cached = client.readQuery<AllCountriesQuery>({
    query: AllCountriesDocument,
  })
  return cached ?? null
}
